<template>
  <div>
    <basic-alert :active="alertActive" :type="alertType" :msg="alertMsg" />
    <view-container
      :col="$vuetify.breakpoint.mobile ? 12 : 6"
      style="padding: 2vh"
    >
      <vue-splash
        :show="splashTime"
        :logo="logo"
        title=""
        color="#005591"
        :size="300"
        :fixed="true"
      />
      <div v-if="!splashTime">
        <div style="margin:2%">
          <v-container>
            <v-row no-gutters>
              <v-col cols="2">
                <basic-btn
                  xLarge
                  icon="mdi-arrow-left"
                  @click="modeSelect ? (modeSelect = false) : back()"
                />
              </v-col>
              <v-col cols="8" class="itemsCenter">
                <h2
                  color="primary"
                  style="color: #005591"
                  v-text="'Carrito de reservas'"
                />
              </v-col>
              <v-col cols="2">
                <basic-btn
                  v-if="modeSelect == false"
                  xLarge
                  icon="mdi-plus"
                  @click="changeMode()"
                />
              </v-col>
            </v-row>
            <!-- <v-row no-gutters class="itemsCenter">
          <v-col md="6" offset-md="3">
            <h2 color="primary" style="color: #00A0E1; " v-text="'04:59'" />
          </v-col>
        </v-row> -->
          </v-container>

          <br />
          <div v-if="modeSelect == false">
            <v-card
              v-for="(item, i) in cardInfo.lugaresInfo"
              :key="item.key"
              class="mx-auto cardStyle"
              color="#0055911e"
              tile
              style="margin-left: 30%;"
              @click="openCard(item, i)"
            >
              <info-list
                info
                :data="reservationFormat(item)"
                :state="item.nombre"
                :activeClick="i == 0 ? false : true"
              />
            </v-card>
          </div>
        </div>
        <div v-if="modeSelect">
          <p
            color="primary"
            style="color: #00A0E1; "
            v-text="'Selecciona un lugar de trabajo a agregar'"
          />
          <v-text-field
            class="rounded-0"
            single-line
            outlined
            rounded
            color="primary"
            background-color="white"
            label="Buscar Lugar De Trabajo"
            persistent-hint
            prepend-inner-icon="mdi-magnify"
            append-icon=""
            @input="search()"
            v-model="text"
          />
          <div class="itemsCenter" v-if="suggestionsError.length > 0">
            <h2
              color="primary"
              style="color: #00A0E1; "
              v-text="suggestionsError"
            />
          </div>
          <div v-for="(data, i) in suggetionsInfo" :key="i">
            <h2
              color="primary"
              style="color: #00A0E1"
              v-text="data.tipoLugarTrabajo"
            />
            <div v-for="(item, j) in suggetionsInfo[i].lugaresTrabajo" :key="j">
              <v-card
                class="mx-auto cardStyle pointer"
                color="#0055911e"
                tile
                style="margin-left: 30%;"
                @click="addReserve(item)"
                v-if="validateBlock(i, j)"
              >
                <info-list :data="selectFormat(item)" info mini outHeader />
              </v-card>
            </div>
          </div>
        </div>
        <v-bottom-sheet v-model="sheet">
          <v-sheet class="text-center" style="padding:2%">
            <view-container style="padding:1vh">
              <h2 style="color: #005591" v-text="'Acciones'" />
              <br />
              <basic-btn
                block
                colorBtn="red"
                dark
                text="Eliminar"
                @click="deleteModal = true"
              />
              <br />
              <basic-btn
                block
                colorBtn="#005591"
                dark
                text="Cancelar"
                @click="sheet = false"
              />
              <br />
            </view-container>
          </v-sheet>
        </v-bottom-sheet>
        <v-dialog v-model="deleteModal" persistent max-width="600">
          <v-card>
            <v-toolbar color="primary" dark>
              <v-spacer></v-spacer>
              <h2 class="tex-right" v-text="'Confirmar cancelación'" />
              <v-spacer></v-spacer>
            </v-toolbar>

            <v-card-text>
              <br />
              <h3>
                ¿Deseas eliminar tu reserva?
              </h3>
              <v-divider></v-divider>
              <div class="itemsCenter">
                <basic-btn
                  text="Cancelar"
                  typeButton="text"
                  @click="deleteModal = !deleteModal"
                />
              </div>
              <v-divider></v-divider>
              <div class="itemsCenter">
                <basic-btn
                  text="Eliminar"
                  typeButton="text"
                  @click="remove()"
                />
              </div>
              <v-divider></v-divider>
            </v-card-text>
          </v-card>
        </v-dialog>
        <v-dialog v-model="reserveModal" persistent max-width="600">
          <v-card>
            <v-toolbar color="primary" dark>
              <v-spacer></v-spacer>
              <h2 class="tex-right" v-text="'Confirmar cancelación'" />
              <v-spacer></v-spacer>
            </v-toolbar>

            <v-card-text>
              <br />
              <h3>
                ¿Deseas confirmar todas las reservas?
              </h3>
              <v-divider></v-divider>
              <div class="itemsCenter">
                <basic-btn
                  colorBtn="grey"
                  text="Cancelar"
                  typeButton="text"
                  @click="reserveModal = !reserveModal"
                />
              </div>
              <v-divider></v-divider>
              <div class="itemsCenter">
                <basic-btn
                  text="Confrimar"
                  typeButton="text"
                  @click="reserveAll()"
                />
              </div>
              <v-divider></v-divider>
            </v-card-text>
          </v-card>
        </v-dialog>
      </div>
    </view-container>
    <v-container v-if="!splashTime">
      <v-row no-gutters>
        <v-col md="6" offset-md="3">
          <basic-btn
            colorBtn="primary"
            block
            text="Confirmar reservaciones"
            @click="reserveModal = true"
            v-if="modeSelect == false"
            bottom
            class="itemsCenter"
          />
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { ViewContainer, BasicBtn, InfoList, BasicAlert } from "@/components";
import { services, time } from "@/utils";
import { logo } from "@/assets";

export default {
  name: "home",
  components: {
    ViewContainer,
    BasicBtn,
    InfoList,
    BasicAlert,
  },
  data: () => ({
    actualLocation: 0,
    workRemove: 0,
    text: "",
    logo: logo,
    splashTime: false,
    suggetionsInfo: [],
    suggetionsBlock: [],
    alertActive: false,
    alertMsg: "",
    suggestionsError: "",
    alertType: "success",
    deleteModal: false,
    cardInfo: [],
    reservationInfo: [
      {
        title: "",
        info: "",
      },
    ],
    sheet: false,
    reserveModal: false,
    modeSelect: false,
    items: [],
    dataCard: undefined,
    generalInfo: {
      zone: "",
      name: "",
      floor: "",
    },
  }),
  mounted() {
    this.initInfo();
  },

  watch: {
    alertActive(new_val) {
      if (new_val) {
        setTimeout(() => {
          this.alertActive = false;
        }, 3000);
      }
    },
  },
  methods: {
    initInfo() {
      this.actualLocation = parseInt(this.$route.params.id);
      this.generalInfo.name = this.$route.params.name;
      this.generalInfo.zone = this.$route.params.zone;
      this.generalInfo.floor = this.$route.params.floor;
      this.$route.query.lugaresInfo = JSON.parse(this.$route.query.lugaresInfo);
      this.$route.query.lugaresTrabajo = JSON.parse(
        this.$route.query.lugaresTrabajo
      );
      if (this.$route.query.fechas) {
        this.$route.query.fechas = JSON.parse(this.$route.query.fechas);
      }
      this.cardInfo = this.$route.query;
      this.cardInfo.lugaresTrabajo = [this.cardInfo.lugaresTrabajo];
    },
    openCard(item, i) {
      if (i > 0) {
        this.workRemove = item.id;
        this.sheet = !this.sheet;
      } else {
        this.alertActive = true;
        this.alertMsg = "Esta reserva no se puede eliminar";
        this.alertType = "error";
      }
    },
    reserveAll() {
      this.splashTime = true;
      let auxInfo = this.cardInfo;
      delete auxInfo.lugaresInfo;
      if (auxInfo.fechas) {
        auxInfo.fechas = JSON.stringify(auxInfo.fechas);
      } else {
        delete auxInfo.fechas;
      }
      auxInfo.empleado = parseInt(auxInfo.empleado);
      auxInfo.lugarTrabajo = parseInt(auxInfo.lugarTrabajo);
      auxInfo.cantidadEmpleados = parseInt(auxInfo.cantidadEmpleados);
      auxInfo.duracionDiaria = parseInt(auxInfo.duracionDiaria);
      auxInfo.tipoRepeticion = parseInt(auxInfo.tipoRepeticion);
      let data = {
        data: auxInfo,
      };
      services
        .ws("post", "cartReservation", data)
        .then((res) => {
          if (res.ok) {
            this.$router.push("/client/Search");
            this.$router.push({
              path: "/client/Search",
              query: {
                alertType: "success",
                alertMsg: "Reserva realizada con exito",
              },
            });
          } else {
            this.alertActive = true;
            this.alertMsg = res.message;
            this.alertType = "error";
            this.splashTime = false;
          }
        })
        .catch((error) => {
          this.alertActive = true;
          this.alertMsg = error.response.data.message;
          this.alertType = "error";
          this.splashTime = false;
        })
        .finally(() => {
          this.loading = false;
          this.sheet = false;
        });
    },
    remove() {
      let data = {
        data: {
          lugarTrabajo: this.workRemove,
          carritoReservacion: this.actualLocation,
        },
      };
      services
        .ws("delete", "cartWorkplace", data)
        .then((res) => {
          if (res.ok) {
            this.alertActive = true;
            this.alertMsg = "Reserva cancelada con exito";
            this.alertType = "success";
            this.removeCard();
          } else {
            this.alertActive = true;
            this.alertMsg = res.message;
            this.alertType = "error";
          }
        })
        .finally(() => {
          this.loading = false;
          this.deleteModal = false;
          this.sheet = false;
        });
    },
    removeCard() {
      let deleteLocation;
      for (let j = 0; j < this.cardInfo.lugaresInfo.length; j++) {
        if (this.workRemove == this.cardInfo.lugaresInfo[j].id) {
          deleteLocation = j;
        }
      }
      if (deleteLocation > 0) {
        this.cardInfo.lugaresInfo.splice(deleteLocation, 1);
        this.cardInfo.lugaresTrabajo.splice(deleteLocation, 1);
      }
    },
    changeMode() {
      this.getSuggetions();
      this.modeSelect = true;
    },
    reservationFormat(item) {
      let reservationInfo = [
        {
          icon1: "mdi-clock-time-eight-outline",
          icon2: "mdi-desk",

          title:
            "<b>Fecha de inicio</b> <br>" +
            time.formatNormal(this.cardInfo.fechaInicio, ` D/MM/YYYY h:mm A`) +
            " a " +
            time.formatNormal(this.cardInfo.fechaFin, "h:mm A"),
          info: this.generalInfo.name,
        },
        {
          title:
            "<b>Duración</b> <br>" +
            (this.cardInfo.fechas
              ? "Todo el día"
              : this.secondsToString(parseInt(this.cardInfo.duracionDiaria))),

          info: this.generalInfo.zone,
        },
        {
          icon1: "mdi-account",
          icon2: "",
          title: item.capacidad ? item.capacidad : "Desconocido",
          info: this.generalInfo.floor,
        },
      ];
      return reservationInfo;
    },
    selectFormat(item) {
      let reservationInfo = [
        {
          title: item.nombre ? item.nombre : "Desconocido",
          info: "Piso: " + (item.piso ? item.piso : "Desconocido"),
        },
        {
          info: "Área: " + (item.area ? item.area : "Desconocido"),
        },
      ];
      return reservationInfo;
    },
    addReserve(item) {
      let data = {
        data: {
          lugarTrabajo: item.id,
          carritoReservacion: this.actualLocation,
        },
      };
      services
        .ws("post", "cartWorkplace", data)
        .then((res) => {
          if (res.ok) {
            this.cardInfo.lugaresInfo.push(item);
            this.cardInfo.lugaresTrabajo.push(item.id);
            this.alertActive = true;
            this.alertMsg = "Reserva agregada correctamente";
            this.alertType = "success";
            // this.modeSelect = false;
          } else {
            this.alertActive = true;
            this.alertMsg = res.message;
            this.alertType = "error";
          }
        })
        .catch((error) => {
          this.alertActive = true;
          this.alertMsg = error.response.data.message;
          this.alertType = "error";
        })
        .finally(() => {
          this.loading = false;
        });
    },
    back() {
      history.back();
    },
    getSuggetions() {
      this.searchImg = true;
      let data = {
        carritoReservacionID: this.actualLocation,
      };
      services
        .ws("get", "cartSuggestions", data, "params")
        .then((res) => {
          if (res.ok) {
            this.suggetionsInfo = res.data;
          } else if (res.code) {
            this.suggestionsError = res.message;
          }
        })
        .catch((error) => {
          this.alertActive = true;
          this.alertMsg = error.response.data.message;
          this.alertType = "error";
        })
        .finally(() => {
          this.suggestionsActive();
        });
    },
    suggestionsActive() {
      for (let i = 0; i < this.suggetionsInfo.length; i++) {
        for (let j = 0; j < this.suggetionsInfo[i].lugaresTrabajo.length; j++) {
          this.suggetionsBlock.push({ n1: i, n2: j, active: true });
        }
      }
    },
    search() {
      let keys = ["nombre", "piso", "area"];
      for (let i = 0; i < this.suggetionsInfo.length; i++) {
        for (let j = 0; j < this.suggetionsInfo[i].lugaresTrabajo.length; j++) {
          let auxSuggetions = this.suggetionsInfo[i].lugaresTrabajo[j];
          let active = false;
          if (this.text != null || this.text != "") {
            let auxText = this.text.toString().toLowerCase();
            for (let key of keys) {
              if (
                auxSuggetions[key]
                  .toString()
                  .toLowerCase()
                  .match(auxText)
              ) {
                active = true;
              }
            }
            for (let k = 0; k < this.suggetionsBlock.length; k++) {
              if (
                this.suggetionsBlock[k].n1 == i &&
                this.suggetionsBlock[k].n2 == j
              ) {
                this.suggetionsBlock[k].active = active;
              }
            }
          }
        }
      }
    },
    validateBlock(n1, n2) {
      let avaible = true;
      for (let i = 0; i < this.suggetionsBlock.length; i++) {
        if (
          this.suggetionsBlock[i].n1 == n1 &&
          this.suggetionsBlock[i].n2 == n2
        ) {
          avaible = this.suggetionsBlock[i].active;
        }
      }
      return avaible;
    },
    secondsToString(seconds) {
      let hour = Math.floor(seconds / 3600);
      hour = hour < 10 ? "0" + hour : hour;
      let minute = Math.floor((seconds / 60) % 60);
      minute = minute < 10 ? "0" + minute : minute;
      let second = seconds % 60;
      second = second < 10 ? "0" + second : second;
      return hour + ":" + minute + ":" + second;
    },
  },
};
</script>

<style scoped>
.cardStyle {
  margin: 15px;
}
p {
  color: #005591;
}
</style>
